import {Injectable} from '@angular/core';
import {GaAction, GoogleAnalyticsService} from 'ngx-google-analytics';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    lang = 'uk';
    prefix = '';

    constructor(
        private translate: TranslateService,
        protected gaService: GoogleAnalyticsService
    ) {
        this.setCurrentLang(translate.currentLang);

        translate.onLangChange.subscribe((data) => {
            this.setCurrentLang(data.lang);
        });
    }

    trackView(path?: string, title?: string) {
        this.gaService.pageView(this.prefix + path, title);
    }

    trackEvent(action: GaAction | string, category?: string, label?: string, value?: number) {
        this.gaService.event(action, category, label, value);
    }

    setCurrentLang(lang) {
        // Робимо зворотний мапінг: якщо Angular працює на внутрішньому 'ua',
        // для систем аналітики та звітів фіксуємо його як офіційний 'uk'
        if (lang === 'ua' || lang === 'uk') {
            this.lang = 'uk';
            // Українська версія головна, в URL префікса немає
            this.prefix = '';
        } else if (lang === 'en') {
            this.lang = 'en';
            this.prefix = '/en';
        } else if (lang === 'ru') {
            this.lang = 'ru';
            this.prefix = '/ru';
        } else {
            this.lang = lang;
            this.prefix = '';
        }
    }
}
